import React from "react";

import styles from "./TosPreview.module.sass"

function getCleanText(text) {
  return text
    .replace(/<h1>/g, "<p><b>")
    .replace(/<\/h1>/g, "</b></p>")
    .replace(/<h2>/g, "<p><b>")
    .replace(/<\/h2>/g, "</b></p>")
    .replace(/<h3>/g, "<p><b>")
    .replace(/<\/h3>/g, "</b></p>");
}

export default function TosPreview({text}) {
  return (
    <div>
      <div
        className={styles.container}
        dangerouslySetInnerHTML={{ __html: getCleanText(text) }}
      ></div>
    </div>
  );
}
